export default __webpack_public_path__ + "static/media/shivji.bb3e5d12.jpg";